import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import { atom, useAtomValue } from 'jotai';

export const screenAsideSlotAtom = atom<HTMLElement | null>(null);

export const ScreenAsidePortal = ({ children }: PropsWithChildren) => {
  const slot = useAtomValue(screenAsideSlotAtom);

  if (!slot) {
    return null;
  }

  return createPortal(children, slot);
};
